import { render, staticRenderFns } from "./bh-flow.vue?vue&type=template&id=faf19dea&lang=pug"
import script from "./bh-flow.vue?vue&type=script&lang=ts"
export * from "./bh-flow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports